// PlatformSpecificModal 组件的样式配置
export const modalStyles = {
  content: { padding: '24px' },
  header: { padding: '24px 24px 16px', borderBottom: 'none' },
};
